export const NAME = 'register';

// User Registration constants
export const REQUEST_REGISTER = 'REQUEST_REGISTER';
export const SUCCESS_REGISTER = 'SUCCESS_REGISTER';
export const FAILURE_REGISTER = 'FAILURE_REGISTER';

// Succès de l'étape Darty (/darty/register) : le back renvoie une URL ?tk=xxx,
// l'authentification réelle (token + user) arrive ensuite via SUCCESS_LOGIN (/auth/login)
export const SUCCESS_DARTY_REGISTER = 'SUCCESS_DARTY_REGISTER';



// WEBPACK FOOTER //
// ./src/services/authentication/register/constants.js